import { useContext, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { API_URL, FILE_UPLOAD_TYPE } from '../constant';
import { LoginContext } from '../context/logincontext';
import { useSnackbar } from 'notistack';
import { isEmpty } from 'lodash';
import * as yup from 'yup';

const validationSchema = yup.object({
  bank_id: yup.number().required('Bank is required'),
  relation_id: yup.number().required('Member is required'),
  name_in_bank: yup.string().required('Name in bank is required'),
  account_no: yup.string().required('Bank account number is required').matches(/^[0-9]{9,18}$/, 'Invalid account number'),
  cheque_number: yup.string().required('Cheque number is required').matches(/^[0-9]+$/, 'Invalid cheque number'),
  count: yup.number().required('Cheque count is required').min(1, 'Minimum count is 1'),
  ifsc_code: yup.string().required('IFSC code is required').matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code'),
})

export default function PdcChequeDialog({ open, onClose, data }) {
  const context = useContext(LoginContext);
  const { enqueueSnackbar } = useSnackbar();
  const [files, setFiles] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [disable, setDisable] = useState(false);

  const initialValues = {
    staff_id: context.user?.los_staff_id,
    relation_id: null,
    bank_id: null,
    name_in_bank: '',
    account_no: '',
    count: '',
    ifsc_code: '',
    cheque_number: '',
    updated_by: context.user?.user_name,
    cheque_id: null
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) =>  {
      handleConfirm(values)
    },
  });

  useEffect(() => {
    async function fetchData() {
      if (data) {
        const bankRes = await axios.get(`${API_URL}/banks/activeENach`)
        if (bankRes?.data?.status === 'success') setBankList(bankRes?.data?.data);
      }
    }
    fetchData();
  }, [data?.loan_id]);

  const handleConfirm = async(body) => {
    setDisable(true);
    body = {...body, loan_id: data[0]?.loan_id,customer_id: data[0]?.customer_id}
    const formData = new FormData();
    if (!isEmpty(files)) {
      formData.append(FILE_UPLOAD_TYPE.PDC_CHEQUE, ...files);
    }
    const requestData = { ...body, doc_type: FILE_UPLOAD_TYPE.PDC_CHEQUE };
    formData.append('data',JSON.stringify(requestData));

    try {
      const response = await axios.post(`${API_URL}/customer/${body.customer_id}/loan/${body.loan_id}/pdc_cheque_details`, formData);
      if (response?.data?.status === 'success') {
        enqueueSnackbar('PDC Cheque successfully saved', { variant: 'success' });
        onClose();
      } else {
        enqueueSnackbar(response?.data?.data?.message, { variant: 'warning' });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, { variant: 'error' });
    } finally {
      formik.resetForm({ values: useFormik.initialValues });
      setDisable(false);
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3 style={{ fontWeight: 'bold', }}>Pdc Cheque Details Form</h3>
        <Button onClick={onClose} color="error" variant="outlined">X</Button>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Box sx={{ p: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="Member" name="relation_id" value={formik.values.relation_id} onChange={formik.handleChange}  error={formik.touched.relation_id && Boolean(formik.errors.relation_id)} helperText={formik.touched.relation_id && formik.errors.relation_id}>
                  {data?.map((member) => (
                    <MenuItem key={member.relation_id} value={member.relation_id}>{`${member.name}-${member.relation_type}-${member.relation}`}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="Bank Name" name="bank_id" value={formik.values.bank_id} onChange={formik.handleChange}  error={formik.touched.bank_id && Boolean(formik.errors.bank_id)} helperText={formik.touched.bank_id && formik.errors.bank_id}>
                  {bankList.map((bank) => (
                    <MenuItem key={bank.bank_id} value={bank.bank_id}>{bank.name}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Name In Bank" name="name_in_bank" value={formik.values.name_in_bank} onChange={formik.handleChange}  error={formik.touched.name_in_bank && Boolean(formik.errors.name_in_bank)} helperText={formik.touched.name_in_bank && formik.errors.name_in_bank} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Bank Account No" name="account_no" value={formik.values.account_no} onChange={formik.handleChange}  error={formik.touched.account_no && Boolean(formik.errors.account_no)} helperText={formik.touched.account_no && formik.errors.account_no} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Cheque Number" name="cheque_number" value={formik.values.cheque_number} onChange={formik.handleChange}  error={formik.touched.cheque_number && Boolean(formik.errors.cheque_number)} helperText={formik.touched.cheque_number && formik.errors.cheque_number} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Cheque Count" name="count" type='number' value={formik.values.count} onChange={formik.handleChange} error={formik.touched.count && Boolean(formik.errors.count)} helperText={formik.touched.count && formik.errors.count}/>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="IFSC Code" name="ifsc_code" value={formik.values.ifsc_code} onChange={formik.handleChange} error={formik.touched.ifsc_code && Boolean(formik.errors.ifsc_code)} helperText={formik.touched.ifsc_code && formik.errors.ifsc_code}/>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth type="file" onChange={(e) => setFiles(Object.values(e.target.files))} />
              </Grid>
            </Grid>
          </Box>
        </form>
      </DialogContent>
      <DialogActions sx={{display:'flex', justifyContent:'center'}}>
        <LoadingButton sx={{width:"30%"}} loading={disable} onClick={formik.handleSubmit} variant="contained" color="primary">Submit</LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
